import Cookies from 'js-cookie'

export const getSavedFundsCusipList = () => {
  const cusipList = Cookies.get('HOMEPAGE_WATCHLIST_FUNDS')

  if (cusipList) {
    return cusipList === '[]'
      ? []
      : // eslint-disable-next-line no-useless-escape
        cusipList.replace(/"|[\[\]']+/g, '').split(',')
  } else {
    return []
  }
}
